import React, { Component } from "react";
import { alertActions } from '../../action/AlertAction';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { accountActions } from "../../action/AccountAction";
import { commonClass } from "../../helpers/commonClass";
import { Helmet } from "react-helmet";
import ImageUploading from 'react-images-uploading';
import { loginActions } from "../../action/loginAction";
import KycCapture from "./KycFaceCapture";
import AllCountries from './CountryKycList.json';
// import countrycode from '../Home/countrycode.json';
const countryLst = AllCountries;
class KycUpdate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Pending: 1,
            Success: 2,
            Restrict: ['jpg','jpeg', 'png'],
            AddrRestrict: ['jpg','jpeg', 'png', 'pdf'],
            GovnProof: "",
            GovnProofString: "",
            Addressproof: "",
            AddressproofString: "",
            myPhotoProof: "",
            kycnumber: "",
            kycnumberError: "",
            ErrorPicNation: "",
            regNationality: "",
            myPhotoProofString: ""

        };
    }
    static getDerivedStateFromProps(props, state) {
        return { details: props.details }
    }

    Governmanetproof = (imageList, addUpdateIndex) => {
        let Isimage = this.MaxSize(imageList)
        if (Isimage) {
            console.log(imageList, addUpdateIndex);
            this.setState({ GovnProof: imageList[0].data_url })
            this.setState({ GovnProofString: imageList[0].file.name })
            // let Profileimgstring = imageList[0].data_url;
        }
    };

    Addressproof = (imageList, addUpdateIndex) => {
        let Isimage = this.MaxSize(imageList)
        if (Isimage) {
            console.log(imageList, addUpdateIndex);
            this.setState({ Addressproof: imageList[0].data_url })
            this.setState({ AddressproofString: imageList[0].file.name })
            // let Profileimgstring = imageList[0].data_url;
        }
    };
    myPhotoProof = (imageList, addUpdateIndex) => {
        let Isimage = this.MaxSize(imageList)
        if (Isimage) {
            console.log(imageList, addUpdateIndex);
            this.setState({ myPhotoProof: imageList[0].data_url })
            this.setState({ myPhotoProofString: imageList[0].file.name })

        }
    };
    MaxSize = (selectedFile) => {
        let fileSize = selectedFile[0].file.size;
        let fileMb = fileSize / (1024 * 1000);
        let maxFileSize = 2; 
        if (fileMb >= maxFileSize) {
            this.showMsg("Maximum image size 2MP");
            return false;
        }
        else {
            return true;
        }
    }

    SubmitKycDoc = () => {
        const { GovnProof, Addressproof, AddressproofString, GovnProofString, myPhotoProof, kycnumber, regNationality } = this.state;
        let validation = true;
        if (!regNationality || regNationality == "") {
            this.showMsg("Please select the Country.", 1);
            validation = false;
        }
        else if (!kycnumber || kycnumber.trim() === "") {
            this.showMsg("Please Enter National ID Number.", 1);
            validation = false;
        }
        else if (kycnumber.length <= 8) {
            this.showMsg("National ID Number Minimum 8 Digit.", 1);
            validation = false;
        }
        if (GovnProof.length <= 0 && Addressproof.length <= 0) {
            this.showMsg("Please Select Documents.")
            return;
        }
        else if (GovnProof.length <= 0) {
            this.showMsg("Government issued ID (e.g., Driver's license, passport).")
            return;
        }
        else if (Addressproof.length <= 0) {
            this.showMsg("Utility bill or bank statement (Issued within the last 3 months).")
            return;
        }
        else if (!myPhotoProof || myPhotoProof.length <= 0) {
            this.showMsg("Please Upload Your Picture.")
            return;
        }
        else if (validation) {
            let Govn_img_name = "GOV_FB_" + this.props.user.mobileNo + "." + GovnProofString.split('.').pop();  // //after name front or back
            let Addres_img_name = "ADDR_FB_" + this.props.user.mobileNo + "." + AddressproofString.split('.').pop(); //after name front or back
            let Myphoto_img_name = "FACE_FB_" + this.props.user.mobileNo + ".jpeg";
            let Myphoto_base = myPhotoProof.split('base64,')[1]

            let Govt_base = GovnProof.split('base64,')[1]
            let Address_base = Addressproof.split('base64,')[1]
            if (Govt_base.length > 1 && Address_base.length > 1) {
                this.props.SubmitKycDocs(Govt_base, Govn_img_name, Address_base, Addres_img_name, Myphoto_base, Myphoto_img_name, this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey, kycnumber, regNationality)
            }
        }
    }

    setErrorMessage = (flagNo, errorstring) => {
        switch (flagNo) {
            case 1:
                this.setState({ kycnumberError: errorstring })
                break;
            default:
                break;
        }
    }

    showMsg = (msg, flagNo) => {
        let errorstring = this.props.t(msg)
        if (flagNo > 0) {
            this.setErrorMessage(flagNo, errorstring)
        }
        else {
            this.props.alertError(errorstring);
        }
    }

    onError = (errors, files) => {
        if (errors.maxFileSize) {
            this.showMsg('File size exceeds 2MB limit.');
        }
    };


    myPhotoUpload = (_myphoto) => {
        this.setState({ myPhotoProof: _myphoto });
    }

    handleChange = (e) => {
        try {
            // Clear Error Message.
            this.SetEmpty()
            if (e.target.name == 'kycnumber') {
                this.setState({ [e.target.name]: e.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase() });

            }
            else if (e.target.name == 'branchname') {
                this.setState({ [e.target.name]: e.target.value.replace(/[^a-z]/gi, '').toUpperCase() });
            }
            else {
                this.setState({ [e.target.name]: e.target.value.toUpperCase() });
            }
        }
        catch (ex) { }
    }

    SetEmpty = () => {
        this.setState({ kycnumberError: "" });
        this.setState({ ErrorPicNation: "" })
    }
    setSelected = (val) => {
        this.setState({ regNationality: val });
    }
    render() {
        const { t } = this.props;
        const maxNumber = 69;
        let ISkycnumberError = this.state.kycnumberError.length > 0;
        let ErrorNational = false;//!this.state.regNationality;
        return (
            <>
                {process.env.REACT_APP_MODE != "development" && <Helmet>
                    <title>Gulf Ticket : Profile</title>
                    <meta name="description" content="Gulf Ticket Profile" />
                </Helmet>
                }
                <>
                    <div class="myAccContHead">
                        <h1><img src="./assets/img/icons/verified.png" /> {t('lblkyccomplete')} </h1>
                        <div class="proChangePass" onClick={() => { this.props.kyccontrolfunc(0) }}><a > {t('lblBack')} </a></div>
                    </div>
                    <div class="requirDocs">
                        <div class="requirDocsHead">
                            <h2>{t('lblrqrdoc')}</h2>
                            <p>{t('lblveriiden')}</p>
                        </div>
                        <div className="kyc-field">
                            <div className="registerInr">
                                <form class="register-form"  >

                                    <div class="formCont">
                                        <label>{t('lblSelCountry')}<sup>*</sup></label>
                                        <div className="nationality">
                                            <select className={`nationalityDropDown ${ErrorNational ? "errorBorder" : ""}`} onChange={(e) => { this.setSelected(e.target.value); this.SetEmpty() }} defaultValue={this.state.regNationality}>
                                                {countryLst && countryLst.map((obj, inx) => (
                                                    <option key={`q_${inx}`} value={obj.Country_Code}>
                                                        {obj.Country_Name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        {ErrorNational && <div class="errorTxt">{this.state.ErrorPicNation}</div>}
                                    </div>

                                    <div class="formCont">
                                        <label>E-KYC ID :<sup>*</sup></label>
                                        <input type="text" className={`${ISkycnumberError ? "errorBorder" : ""}`} id="txtAmount" placeholder="KYC Proof Number*" maxLength={20} name="kycnumber" value={this.state.kycnumber} onChange={(e) => this.handleChange(e)} autoComplete="off" />
                                        {ISkycnumberError && <div class="errorTxt">{this.state.kycnumberError}</div>}
                                    </div>
                                </form>
                            </div>
                        </div>


                        <div class="requirDocsInfo">
                            <div class="requirDocsInfoLi">
                                <div>
                                    <img src="./assets/img/icons/id.png" />
                                </div>
                                <div>
                                    <h3>{t('lblidveri')}({this.state.Restrict.join(',')}) : {this.state.GovnProofString}</h3>
                                    <p>{t('lblproof')}</p>
                                </div>
                                <div>
                                    <label class="upload-btn">
                                        <img src="./assets/img/icons/uparrow.png" alt="Upload Icon" />
                                        {t('lbluploaddoc')}
                                        {/* <input type="file" class="upload-input" /> */}
                                        <ImageUploading
                                            multiple
                                            onChange={this.Governmanetproof}
                                            maxNumber={maxNumber}
                                            dataURLKey="data_url"
                                            acceptType={this.state.Restrict}
                                        >
                                            {({
                                                acceptType = ['.png', '.jpg,', '.jpeg'],
                                                onImageUpload,
                                                dragProps,
                                            }) => (
                                                <div>
                                                    <input name="GovnProof" type="file" onClick={onImageUpload} {...dragProps} {...acceptType} class="upload-input" />
                                                    {/* <span onClick={onImageUpload} {...dragProps} {...acceptType} >
                                                        <p>Upload Bank Passbook :{this.state.BankImgName}</p>
                                                    </span> */}
                                                </div>
                                            )}
                                        </ImageUploading>
                                    </label>
                                </div>
                            </div>
                            <div class="requirDocsInfoLi">
                                <div>
                                    <img src="./assets/img/icons/address.png" />
                                </div>
                                <div>
                                    <h3>{t('lbladdverificn')}({this.state.AddrRestrict.join(',')}) : {this.state.AddressproofString} </h3>
                                    <p>{t('lblutilbank')}</p>
                                </div>
                                <div>
                                    <label class="upload-btn">
                                        <img src="./assets/img/icons/uparrow.png" alt="Upload Icon" />
                                        {t('lbluploaddoc')}
                                        {/* <input type="file" class="upload-input" /> */}
                                        <ImageUploading
                                            multiple
                                            onChange={this.Addressproof}
                                            maxNumber={maxNumber}
                                            dataURLKey="data_url"
                                            allowNonImageType='true'
                                            acceptType={this.state.AddrRestrict}
                                        >
                                            {({
                                                acceptType = ['.jpeg', '.jpg', '.pdf'],
                                                onImageUpload,
                                                dragProps,
                                            }) => (
                                                <div>
                                                    <input name="Addressproof" type="file" onClick={onImageUpload} {...dragProps} {...acceptType} class="upload-input" />
                                                    {/* <span onClick={onImageUpload} {...dragProps} {...acceptType} >
                                                        <p>Upload Bank Passbook :{this.state.BankImgName}</p>
                                                    </span> */}
                                                </div>
                                            )}
                                        </ImageUploading>
                                    </label>
                                </div>
                            </div>
                            <div class="requirDocsInfoLi">
                                <div>
                                    <img src="./assets/img/icons/selfie.png" />
                                </div>
                                <div>
                                    <h3>{t("lblSelfiePhoto")}</h3>
                                    <p>({t("lblTakePictureNormalBg")})</p>
                                </div>
                                <div class="requirDocsInfoLi">
                                    <div>
                                        <label class="upload-btn">
                                            <img src="./assets/img/icons/uparrow.png" alt="Upload Icon" />
                                            {t("lblSelectPhoto")} {this.state.myPhotoProofString ? this.state.myPhotoProofString : ""}
                                            <ImageUploading
                                                multiple
                                                onChange={this.myPhotoProof}
                                                maxNumber={maxNumber}
                                                dataURLKey="data_url"
                                                acceptType={this.state.Restrict}
                                            >
                                                {({
                                                    acceptType = ['.png', '.jpg','.jpeg'],
                                                    onImageUpload,
                                                    dragProps,
                                                }) => (
                                                    <div>
                                                        <input name="myPhotoProof" type="file" onClick={onImageUpload} {...dragProps} {...acceptType} class="upload-input" />
                                                    </div>
                                                )}
                                            </ImageUploading>
                                        </label>
                                    </div>
                                    <label class="upload-btn" onClick={() => { this.setState({ opencam: (this.state.opencam == 1 ? 0 : 1) }) }}>
                                        {/* <img src="./assets/img/icons/uparrow.png" alt="Upload Icon" /> */}
                                        {this.state.opencam == 1 ? t("lblCloseCamera") : t("lblOpenCamera")}
                                    </label>
                                </div>
                            </div>
                            {this.state.opencam == 1 && <KycCapture myPhotoUpload={this.myPhotoUpload} />}
                            {(this.state.opencam != 1 || this.state.myPhotoProof != "") && <a onClick={() => { this.SubmitKycDoc() }}> {t('lblsubverification')} </a>}
                        </div>
                    </div>
                </>

            </>
        );
    }
}
function mapStateToProps(state) {
    const { user, appvariables } = state.loginReducer;
    const { details } = state.accountReducer;
    return { user, details, appvariables };
}
const mapActionToProps = {
    alertError: alertActions.error,
    SubmitKycDocs: loginActions.SubmitKycDocs
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(KycUpdate))